import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { AskUpdateModule } from '../ask-update/ask-update.module';
import { FbShareModule } from '../fb-share/fb-share.module';
import { WhatsappShareModule } from '../whatsapp-share/whatsapp-share.module';
import { ThankyouBannerComponent } from './components/thankyou-banner/thankyou-banner.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    WhatsappShareModule,
    FbShareModule,
    AskUpdateModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,

  ],
  declarations: [ThankyouBannerComponent],
  exports: [ThankyouBannerComponent],
})
export class ThankyouBannerModule { }
